import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

const AssignedToColumn = ({ userId }) => {
  const users = useSelector(Global.selectSellerUsers);

  if (!userId || !users) {
    return <span>&apos;&apos;</span>;
  }

  const matchingUser = users.find((user) => user.userId === userId);
  return <span>{matchingUser?.name ?? ''}</span>;
};

AssignedToColumn.propTypes = {
  userId: PropTypes.string.isRequired,
};

export default React.memo(AssignedToColumn);
